import Upload from '@/docs-partials/api/endpoints/upload.mdx';
import * as React from 'react';
export default {
  Upload,
  React
};